/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../common/redux/hooks';
import YourCompany from './YourCompany';

export default function YourCompanyPage(): ReactElement {
    const navigate = useNavigate();
    const registerForLaborJobs = useAppSelector(
        ({ contractorRegistration }) =>
            contractorRegistration.contractor.registerForLaborJobs
    );

    const handleBackClick = () => navigate('/contractor/getStarted');
    const handleNextClick = () => {
        const route = registerForLaborJobs
            ? '/contractor/laborInfo'
            : '/contractor/documents';
        navigate(route);
    };

    return (
        <YourCompany
            handleBackClick={handleBackClick}
            handleNextClick={handleNextClick}
        />
    );
}
